import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  ApplicationResult,
  Button,
} from '@cibli/shared';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type ConfirmApplyToJobDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onClose?: () => void;
  onConfirm?: () => void;
  applicationResult?: ApplicationResult | null;
};

export default function ConfirmApplyToJobDialog({
  open,
  onOpenChange,
  onClose,
  onConfirm,
  applicationResult,
}: ConfirmApplyToJobDialogProps) {
  const { t } = useTranslation();

  const handleClose = () => {
    onOpenChange(false);
    onClose?.();
  };

  const handleConfirm = () => {
    onOpenChange(false);
    onConfirm?.();
  };

  const [titleKey, descriptionKey] = useMemo(() => {
    switch (applicationResult) {
      case ApplicationResult.INFO_SENT_SMS:
        return ['ConfirmApplyToJobDialog.title_sms', 'ConfirmApplyToJobDialog.description_sms'];
      case ApplicationResult.INFO_SENT_EMAIL:
        return ['ConfirmApplyToJobDialog.title_email', 'ConfirmApplyToJobDialog.description_email'];
      case ApplicationResult.APPLIED:
      default:
        return ['ConfirmApplyToJobDialog.title', 'ConfirmApplyToJobDialog.description'];
    }
  }, [applicationResult]);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:min-w-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-2xl font-bold">{t(titleKey)}</AlertDialogTitle>
          <AlertDialogDescription className="text-lg">{t(descriptionKey)}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button size="lg" onClick={onConfirm ? handleConfirm : handleClose}>
            {t('ConfirmApplyToJobDialog.close')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
